import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges, ViewChildren, QueryList } from '@angular/core';
import { WFStepLocalResource, WfTaskLocalResource } from 'src/app/components/workflow/workflow';
import { Checklist, ChecklistTemplate } from '../../checklists';
import { ChecklistStepComponent } from './checklist-step/checklist-step.component';
import { utils } from 'src/app/modules/libs/utils';

@Component({
  selector: "checklist-steps",
  templateUrl: "./checklist-steps.component.html",
  styleUrls: ["./checklist-steps.component.scss"],
})
export class ChecklistStepsComponent implements OnChanges {
  @Input() currentChecklist?: Checklist | null;
  @Input() currentChecklistTemplate?: ChecklistTemplate;
  @Input() steps?: WFStepLocalResource[];
  @Input() precheck?: boolean;
  @Input() disabled?: boolean;

  @Output() checkShared = new EventEmitter<any>();
  @Output() taskChanged = new EventEmitter<WfTaskLocalResource>();
  @Output() viewportChanged = new EventEmitter<void>();

  @ViewChildren(ChecklistStepComponent) public stepComponents!: QueryList<ChecklistStepComponent>;

  ngOnChanges(changes: SimpleChanges) {
    this.steps = this.steps?.sort((a, b) => a.order - b.order);
  }

  /**
   * Returns steps that are available in the current status and contain at least one visible task.
   */
  get visibleSteps(): WFStepLocalResource[] {
    return this.steps?.filter(step => {
      const hidden = step.wfStepStatusLocals
        ?.find(status => status.status == this.currentChecklist?.checklistStatusID)?.hidden ?? false;
      const statusDisabled = !step.wfStepStatusLocals
        .map(status => status.status).includes(this.currentChecklist?.checklistStatusID);
      // Hide-mode tasks should not keep their step visible when status-disabled.
      const hasVisibleTasks = step.wfTaskLocals?.some(task => {
        const disableInsteadOfHide = !!utils.JSONparse(task.configuration)?.hideDisable;
        return task.required !== false &&
          (!(statusDisabled || this.disabled) || !task.condition || disableInsteadOfHide);
      }) ?? false;
      return !hidden && hasVisibleTasks;
    }) ?? [];
  }

  trackByStepId(_index: number, step: WFStepLocalResource): number {
    return step.id;
  }

}
